import { Button, Panel, Table } from '@/components/Bicester';
import { PopoverWrapper } from '@/components/Bicester/PopoverWrapper';
import { Cell } from '@/components/Bicester/Table';
import { LevelCell, UserNameCell } from '@/components/Bicester/Table/Cells';
import { BICESTER_FULL_DATE } from '@/constants/dateFormat';
import dayjs from 'dayjs';
import React from 'react';

const ExchangeableTicket = ({
  data,
  loading,
  onExchange,
  onChange,
}: {
  data: any;
  loading: boolean;
  onExchange: (id: number, ticket_id: string) => void;
  onChange: (params: any) => void;
}) => {
  return (
    <Panel leftShadow title="可兑换卡券" subTitle={`总计 ${data?.total || 0} 条`}>
      <Table
        pageInfo={{ page: data?.current_page, total: data?.total }}
        data={data?.content_list || []}
        columns={[
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '卡券号',
            cell: <Cell dataKey="ticket_id" />,
          },
          {
            columnProps: {
              flexGrow: 1,
            },
            header: '客户名',
            cell: <UserNameCell dataKey="user_name" />,
          },
          {
            columnProps: {
              flexGrow: 1.5,
            },
            header: '手机号',
            cell: <Cell dataKey="phone" />,
          },
          {
            columnProps: { flexGrow: 1 },
            header: '会员等级',
            cell: <LevelCell dataKey="level" />,
          },
          {
            columnProps: {
              flexGrow: 5,
            },
            header: '卡券名/卡券所属活动',
            cell: (
              <Cell>
                {(rowData) => (
                  <PopoverWrapper
                    trigger="click"
                    popover={{
                      content: (
                        <div className="p-[40px]">
                          <div className="max-w-[450px] max-h-[450px] overflow-y-scroll text-[#455255]">
                            <div className="mb-[20px]">卡券详情</div>
                            {rowData?.coupons_name && <div>{rowData?.coupons_name}</div>}
                            {rowData?.ticket_act_name && (
                              <div>活动：{rowData?.ticket_act_name}</div>
                            )}
                            <div dangerouslySetInnerHTML={{ __html: rowData?.describe }}></div>
                          </div>
                        </div>
                      ),
                    }}
                  >
                    <div className="multiline-cell-content-wrap">
                      {rowData?.coupons_name && (
                        <div className="multiline-cell-content">{rowData?.coupons_name}</div>
                      )}
                      {rowData?.ticket_act_name && (
                        <div className="multiline-cell-content">
                          活动：{rowData?.ticket_act_name}
                        </div>
                      )}
                    </div>
                  </PopoverWrapper>
                )}
              </Cell>
            ),
          },
          {
            columnProps: {
              flexGrow: 2,
            },
            header: '卡券有效期',
            cell: (
              <Cell>
                {(rowData) => {
                  return (
                    <div className="multiline-cell-content-wrap">
                      {rowData?.start_at && (
                        <div className="multiline-cell-content">
                          开始{dayjs(rowData?.start_at).format(BICESTER_FULL_DATE)}
                        </div>
                      )}
                      {rowData?.end_at && (
                        <div className="multiline-cell-content">
                          结束{dayjs(rowData?.end_at).format(BICESTER_FULL_DATE)}
                        </div>
                      )}
                    </div>
                  );
                }}
              </Cell>
            ),
          },
          {
            columnProps: {
              flexGrow: 1,
            },
            header: '状态',
            cell: <Cell dataKey="status">待兑换</Cell>,
          },
          {
            columnProps: {
              flexGrow: 1,
            },
            header: '操作',
            cell: (
              <Cell>
                {(rowData) =>
                  // is_exchange 是否能兑换 0否1是
                  rowData?.is_exchange === 1 && (
                    <Button
                      appearance="link"
                      onClick={() => onExchange(rowData?.id, rowData?.ticket_id)}
                    >
                      兑换
                    </Button>
                  )
                }
              </Cell>
            ),
          },
        ]}
        onChange={onChange}
        loading={loading}
      >
        <Table.Body height={289} rowHeight={64} />
        <Table.Pagination style={{ ...(data?.total === 0 && { visibility: 'hidden' }) }} />
      </Table>
    </Panel>
  );
};

export default ExchangeableTicket;
